export default {
    name: 'v5-icon-success-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 85.333c235.637 0 426.667 191.03 426.667 426.667S747.637 938.667 512 938.667 85.333 747.637 85.333 512 276.363 85.333 512 85.333zm182.613 297.355a32 32 0 00-45.258.032L458.923 573.44l-84.342-83.99a32 32 0 00-45.162 45.345l106.986 106.549a32 32 0 0045.227-.064l213.013-213.333a32 32 0 00-.032-45.259z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
